module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_american-village-97e5d0fa9bac79ab7d91af9ebb958440.webp";